import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { EmailRow } from "./EmailRow";

const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9äöüß]+/g, "-");

function Group({ group, showTarget, onChanged }) {
  const [open, setOpen] = useState(true);
  return (
    <section className="space-y-2" data-testid={`mail-group-${slug(group.key)}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 py-1.5 text-left border-b hover:text-primary transition-colors" data-testid={`mail-group-toggle-${slug(group.key)}`}>
        {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        <span className="font-semibold">{group.label}</span>
        <span className="text-xs rounded-full bg-muted px-2 py-0.5" data-testid={`mail-group-count-${slug(group.key)}`}>{group.items.length}</span>
      </button>
      {open && group.items.map((e) => <EmailRow key={e.id} email={e} showTarget={showTarget} onChanged={onChanged} />)}
    </section>
  );
}

export function groupEmails(items, view, topics) {
  const map = new Map();
  const push = (key, label, e) => {
    if (!map.has(key)) map.set(key, { key, label, items: [] });
    map.get(key).items.push(e);
  };
  for (const e of items) {
    if (view === "target") {
      if (e.status === "assigned" && e.target_id) push(`${e.target_type}-${e.target_id}`, `${e.target_type === "vendor" ? "Hersteller" : "Kunde"}: ${e.target_name}`, e);
      else push("unassigned", "Nicht zugeordnet", e);
    } else {
      const t = topics.find((x) => x.id === e.topic_id);
      push(t ? t.id : "pending", t ? t.name : "Wird eingeordnet…", e);
    }
  }
  const groups = [...map.values()];
  if (view === "topic") {
    const order = (g) => { const i = topics.findIndex((t) => t.id === g.key); return i < 0 ? 999 : i; };
    return groups.sort((a, b) => order(a) - order(b));
  }
  return groups.sort((a, b) => b.items.length - a.items.length || a.label.localeCompare(b.label, "de"));
}

export function GroupedEmails({ groups, showTarget, onChanged }) {
  return <div className="space-y-5">{groups.map((g) => <Group key={g.key} group={g} showTarget={showTarget} onChanged={onChanged} />)}</div>;
}
